import React from 'react';
import './NoBankStopTransfer.scss';
import Phone from '../../Shared/Phone/Phone';

const NoBankStopTransfer = (customerWebViewEnabled, isSalesforceRep) => (
  <div>
    <div className="no-bank-stop-transfer-block-message-a stop-transfer-block-message-a">
      A block has been placed on adding new banks to this account.
    </div>

    {!(!customerWebViewEnabled && isSalesforceRep) && (
      <div className="no-bank-stop-transfer-block-message-b stop-transfer-block-message-b">
        Call <Phone phoneNumber="(877) 495-8459" /> and speak with an associate.
      </div>
    )}
  </div>
);

export default NoBankStopTransfer;
